export default __webpack_public_path__ + "static/media/desktop_hero_02.c3e26a0a.jpg";